import DataTableView from "@components/views/datatable-view";
import LoadingButton from "@components/ui-components/loading-button";
import UpsertHealthScore from "./upsert";
import useHealthScores from "./use-health-scores";
import usePageChange from "@hooks/use-page-change";
const HealthScores = () => {
    const {
        data: { healthScores = [], pagination = {} },
        loading,
        columns,
        setQueryParams,
        modalConfig,
        handleModalConfig,
        getHealthScores
    } = useHealthScores();

    /* A custom hook that is used to handle the pagination. */
    const { handlePageChange, handlePerRowsChange } = usePageChange({
        setQueryParams
    });

    return (
        <>
            <DataTableView
                moduleName="Health Scores"
                breadcrumbItems={{
                    items: [
                        {
                            title : "Health Score",
                            active: true
                        }
                    ]
                }}
                loading={loading}
                tableProps={{
                    data: healthScores,
                    columns,
                    handlePageChange,
                    handlePerRowsChange,
                    pagination
                }}
                actionItems={
                    <LoadingButton
                        color="primary"
                        icon="plus"
                        testId="add-score"
                        onClick={() => handleModalConfig()}
                        subject="health-scores"
                        text="Add Score"/>
                }/>
            <UpsertHealthScore
                handleModalConfig={handleModalConfig}
                modalConfig={modalConfig}
                getHealthScores={getHealthScores}/>
        </>
    );
};

export default HealthScores;
